export enum TipoDependencia {
    Nacional = 'nacional',
    Brasil = 'brasil',
    Estadual = 'estado',
    Municipal = 'municipio'
}
